import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  width: 100%;
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px 16px;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  transition: all 0.2s ease-in-out;
  background-color: #ffffff;
  color: #2d3748;

  &:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }

  &:hover:not(:focus) {
    border-color: #cbd5e0;
  }

  &::placeholder {
    color: #a0aec0;
  }

  &:disabled {
    background-color: #f7fafc;
    border-color: #e2e8f0;
    color: #a0aec0;
    cursor: not-allowed;
  }
`;

export const BondRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
  width: 100%;
`;

export const BondRowItem = styled.div`
  flex: 1;
  min-width: 250px;
`;

export const CurrencyRowItem = styled.div`
  flex: 0.5;
  min-width: 150px;
`;

export const AttachButtonContainer = styled.div`
  flex: 0 0 120px;
  display: flex;
  align-items: flex-end;
`;

export const DeleteRowButton = styled.button`
  background: none;
  border: none;
  color: #FF0000;
  cursor: pointer;
  font-size: 20px;
  padding: 0;
  margin-left: 8px;
  align-self: flex-end;
  margin-bottom: 8px;
  
  &:hover {
    color: #CC0000;
  }
`;

export const FileCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 5px;
`;

export const FileName = styled.span`
  font-size: 14px;
  color: #5E5873;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #FF0000;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  margin-left: 8px;
  
  &:hover {
    color: #CC0000;
  }
`;

export const BottomFieldsContainer = styled.div`
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #eee;
`;

// Custom Dropdown Styled Components
export const DropdownContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const DropdownButton = styled.div<{ isOpen: boolean; hasValue: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid ${props => props.isOpen ? '#FF6D1D' : '#E0E0E0'};
  border-radius: 8px;
  background-color: white;
  cursor: pointer;
  font-size: 16px;
  color: ${props => props.hasValue ? '#333' : '#999'};
  transition: all 0.2s ease;
  height: 48px;
  box-sizing: border-box;
  
  &:hover {
    border-color: #FF6D1D;
  }
`;

export const DropdownArrow = styled.div<{ isOpen: boolean }>`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
  transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 0.2s ease;
`;

export const DropdownList = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 300px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #E0E0E0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: ${props => props.isOpen ? 'block' : 'none'};
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-bottom: 1px solid #E0E0E0;
  font-size: 16px;
  outline: none;
  
  &:focus {
    border-bottom-color: #FF6D1D;
  }
`;

export const DropdownItem = styled.div<{ isSelected: boolean; isHighlighted: boolean }>`
  padding: 12px 16px;
  cursor: pointer;
  background-color: ${props => {
    if (props.isSelected) return '#FF6D1D';
    if (props.isHighlighted) return '#FFF3E0';
    return 'white';
  }};
  color: ${props => props.isSelected ? 'white' : '#333'};
  
  &:hover {
    background-color: ${props => props.isSelected ? '#FF6D1D' : '#FFF3E0'};
  }
`;

export const Label = styled.label`
  display: block;
  font-size: 12px;
  margin-bottom: 4px;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 18px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: #666;
  }
`;
